import L from "leaflet";
import { defineNuxtPlugin } from "#imports";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      l: L
    }
  };
});
export type LeafletProvide = typeof L
